import { render, staticRenderFns } from "./RectifierPreOrders.vue?vue&type=template&id=9d7477a8&scoped=true"
import script from "./RectifierPreOrders.vue?vue&type=script&lang=js"
export * from "./RectifierPreOrders.vue?vue&type=script&lang=js"
import style0 from "./RectifierPreOrders.vue?vue&type=style&index=0&id=9d7477a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d7477a8",
  null
  
)

/* custom blocks */
import block0 from "./resources/locales.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fgithub%2Fworkspace%2Fsrc%2Fviews%2Forder%2Frectifier-pre-orders%2FRectifierPreOrders.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports